import React, { useState } from 'react';
import { Menu, Avatar, IconButton, Grid2 } from '@mui/material';
import { useAuth } from '../Auth/AuthContext';
import { ArrowDownwardOutlined, FavoriteBorderOutlined, Delete, PercentSharp, Favorite, ArrowUpwardOutlined } from '@mui/icons-material';
import './UserProfileMenu.css'; // Archivo CSS para los estilos personalizados
import { useNavigate } from 'react-router-dom';
import { useApi } from '../../services/ApiServices';

const defaultAvatar = require('../../assets/img/chilin-profile.png');

interface UserProfileMenuProps {
  avatar?: string; // URL del avatar del usuario
  name: string; // Nombre del usuario (puedes usarlo si necesitas mostrarlo)
}

const UserProfileMenu: React.FC<UserProfileMenuProps> = ({ avatar, name }) => {
  const { user, logout } = useAuth();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const navigate = useNavigate();
  const { ApiRequest } = useApi();

  const handleMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };
  const handleGoToProfile = () => {
    setAnchorEl(null);
    navigate('/UserProfile');
  };

  const handleLogout = async () => {
    try {
      await ApiRequest('api/Auth/Logout', 'POST', null, true);
      logout();
    } catch (error) {
      console.error("Error al cerrar sesión:", error);
      logout(); // Cierra sesión local de todos modos
    }
  };

  return (
    <Grid2 style={{ display: 'flex', alignItems: 'center' }}>
      {/* Imagen del usuario */}
      <Avatar 
        src={avatar || defaultAvatar} 
        alt={user?.name} 
        sx={{ width: 56, height: 56, marginRight: '8px' }} 
      />
      
      {/* Botón con flecha */}
      <IconButton onClick={handleMenuOpen}>
        {anchorEl ? (
            <ArrowUpwardOutlined />
        ) : (
            <ArrowDownwardOutlined />
        )}
      </IconButton>

      {/* Menú personalizado */}
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleMenuClose}
        PaperProps={{
          style: {
            width: '500px',
            padding: '0px',
            backgroundColor: 'transparent',
            border: 'none',
            boxShadow: 'none',
          },
        }}
      >
        <Grid2 className="popup-container">

          <Grid2 className="popup-header">
            <Avatar 
              src={avatar || defaultAvatar} 
              alt={user?.name} 
              sx={{ width: 88, height: 88, marginRight: '8px' }} 
            />
            <Grid2 className="popup-user-info">
              <p className="user-name">{user?.name}</p>
              <p className="user-email">{user?.email}</p>
              <button onClick={handleLogout} className="logout-button">Cerrar sesión</button>
            </Grid2>
          </Grid2>

          <Grid2 className="popup-content">
            <p className="section-title">Tu cuenta</p>

            <Grid2 className="menu-item">
              <Grid2 className="menu-item-left">
                <FavoriteBorderOutlined className="icon-heart" />
                <span>Favoritos</span>
              </Grid2>
              <i className="icon-chevron-down"></i>
            </Grid2>


            <Grid2 className="submenu">
              <Grid2 className="submenu-item" onClick={() => {navigate("/recetas?usuario=true")}}>
                {/*<Favorite className="icon-heart-red"/>*/}
                <i className="icon-transparent"></i>
                <span>Recetas</span>
              </Grid2>
              <Grid2 className="submenu-item" onClick={() => {navigate("/tips?usuario=true")}}>
                <i className="icon-transparent"></i>
                <span>Tips</span>
              </Grid2>
            </Grid2>


            {/*
            <hr className="separator" />

            <Grid2 className="menu-item">
              <Grid2 className="menu-item-left">
                <PercentSharp className="icon-heart" />
                <span>Promociones</span>
              </Grid2>
              <i className="icon-chevron-down"></i>
            </Grid2>
            */}

            <hr className="separator" />

            <Grid2 className="menu-item" onClick={handleGoToProfile}>
              <Grid2 className="menu-item-left">
                <i className="icon-transparent"></i>
                <span>Personaliza tu experiencia</span>
                {/*<button onClick={logout} className="logout-button">Personaliza tu experiencia</button>*/}
              </Grid2>
              <i className="icon-chevron-down"></i>
            </Grid2>
          </Grid2>
        </Grid2>
      </Menu>
    </Grid2>
  );
}; 

export default UserProfileMenu;
